import { useGenerateTreatmentPlanPdf } from '@/api/generate-treatment-plan-pdf';
import { Button } from '../button';
import { ReactNode } from 'react';
import { downloadFile } from '@/util/helpers';

interface DownloadTreatmentPlanButtonProps {
  encounterId: number;
  children: ReactNode;
  fileName: string;
  className?: string;
}

export function DownloadTreatmentPlanButton({
  encounterId,
  className,
  fileName,
  children,
}: DownloadTreatmentPlanButtonProps) {
  const { mutate: generateTreatmentPlanPdf, isPending } = useGenerateTreatmentPlanPdf();

  const handleDownloadPdf = () => {
    generateTreatmentPlanPdf(
      { encounterId },
      { onSuccess: (data) => downloadFile(data, fileName) },
    );
  };

  return (
    <Button
      variant="link"
      leftIcon="description"
      loading={isPending}
      onClick={handleDownloadPdf}
      className={className}
    >
      {children}
    </Button>
  );
}
